//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Overzicht van de ORV producten waar de overlijdens risico premie van berekend kan worden.
     * @return De lijst met gevonden producten
     */
    availableProducts(): Promise<Product[]> {
        let url_ = this.baseUrl + "/Producten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAvailableProducts(_response);
        });
    }

    protected processAvailableProducts(response: Response): Promise<Product[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Foutmeldingen;
            return throwException("Er is iets fout gegaan", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product[]>(null as any);
    }

    /**
     * Overlijdens risico premie berekening voor één of meerdere producten.
     * @param body (optional) Parameters voor de berekening
     * @return Het resultaat van de berekening
     */
    multiple(body: MultipleOrvInput | undefined): Promise<OverlijdensRisicoOutput> {
        let url_ = this.baseUrl + "/Multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMultiple(_response);
        });
    }

    protected processMultiple(response: Response): Promise<OverlijdensRisicoOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverlijdensRisicoOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverlijdensRisicoOutput;
            return throwException("Er is iets fout gegaan", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverlijdensRisicoOutput>(null as any);
    }

    /**
     * Overlijdens risico premie berekening voor alle producten.
     * @param body (optional) Input nodig voor de berekening.
     * @return Het resultaat van de berekening
     */
    all(body: OverlijdensRisicoInput | undefined): Promise<OverlijdensRisicoOutput> {
        let url_ = this.baseUrl + "/All";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<OverlijdensRisicoOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverlijdensRisicoOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("Er is iets fout gegaan", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverlijdensRisicoOutput>(null as any);
    }

    /**
     * Geeft de validaties voor de gegeven producten.
     * @return Success
     */
    geef_validaties_van_meerdere_producten(productcodes: number[]): Promise<ValidatiesOutput> {
        let url_ = this.baseUrl + "/Validaties/{productcodes}";
        if (productcodes === undefined || productcodes === null)
            throw new Error("The parameter 'productcodes' must be defined.");
        url_ = url_.replace("{productcodes}", encodeURIComponent(productcodes.join()));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeef_validaties_van_meerdere_producten(_response);
        });
    }

    protected processGeef_validaties_van_meerdere_producten(response: Response): Promise<ValidatiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidatiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidatiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidatiesOutput>(null as any);
    }

    /**
     * Geeft de validaties voor alle producten.
     * @return Success
     */
    geef_validaties_van_alle_producten(): Promise<ValidatiesOutput> {
        let url_ = this.baseUrl + "/Validaties/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeef_validaties_van_alle_producten(_response);
        });
    }

    protected processGeef_validaties_van_alle_producten(response: Response): Promise<ValidatiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidatiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidatiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidatiesOutput>(null as any);
    }

    /**
     * Maakt een validatie aan voor een bepaald product.
     * @param body (optional) 
     * @return Created
     */
    validatie_voor_product_aanmaken(productcode: number, body: Validatie | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Validaties/{productcode}";
        if (productcode === undefined || productcode === null)
            throw new Error("The parameter 'productcode' must be defined.");
        url_ = url_.replace("{productcode}", encodeURIComponent("" + productcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidatie_voor_product_aanmaken(_response);
        });
    }

    protected processValidatie_voor_product_aanmaken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidatiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Wijzigt een validatie aan voor een bepaald product.
     * @param body (optional) 
     * @return No Content
     */
    validatie_voor_product_wijzigen(productcode: number, body: Validatie | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Validaties/{productcode}";
        if (productcode === undefined || productcode === null)
            throw new Error("The parameter 'productcode' must be defined.");
        url_ = url_.replace("{productcode}", encodeURIComponent("" + productcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidatie_voor_product_wijzigen(_response);
        });
    }

    protected processValidatie_voor_product_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidatiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }
}

export interface BadRequestResult {
    statusCode: number;
}

/** BetalingstermijnOpties PerMaand = 1, PerKwartaal = 3, PerHalfJaar = 6, PerJaar = 12 */
export enum BetalingstermijnOpties {
    PerMaand = "PerMaand",
    PerKwartaal = "PerKwartaal",
    PerHalfJaar = "PerHalfJaar",
    PerJaar = "PerJaar",
}

/** Geeft een eenvoudige mogelijkheid om foutmeldingen door te geven. */
export interface Foutmeldingen {
    messages: string[] | null;
    isValid: boolean;
}

/** GeslachtOpties Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Man = "Man",
    Vrouw = "Vrouw",
}

/** Input voor het berekenen van overlijdens risico met meerdere producten */
export interface MultipleOrvInput {
    data: OverlijdensRisicoInput;
    /** Lijst met te berekenen producten */
    producten: number[] | null;
}

/** Algemene gegevens van de overlijdensrisicoverzekering. */
export interface OverlijdensRisicoAlgemeenInput {
    /** Ingangsdatum van verzekering */
    ingangsDatum: string;
    /** Looptijd in maanden */
    looptijdInMaanden: number;
    /** Is verpand */
    verpand: boolean;
    premieVerloop: PremieverloopOpties;
    /** Premie is gesplitst */
    premieSplitsing: boolean | null;
    /** Dekt kinderen */
    kindDekking: boolean | null;
    /** Indicatie of er al dan niet sprake is van een premiereserve (waardeopbouw) */
    premiereserve: boolean | null;
}

/** Invoer voor de berekening van een overlijdensrisicoverzekering. */
export interface OverlijdensRisicoInput {
    /** Unieke identificatie */
    id: string;
    algemeen: OverlijdensRisicoAlgemeenInput;
    /** Gegevens over de verzekerden. Let op! Bij gebruik van XML is het ArrayItem verzekerde in plaats van de in Swagger gegenereerde verzekerden. */
    verzekerden: OverlijdensRisicoVerzekerdeInput[] | null;
    premie: OverlijdensRisicoVerzekeringInput;
}

/** Resultaat van de berekeningen */
export interface OverlijdensRisicoOutput {
    /** Uitvoer van de berekening van een overlijdensrisicoverzekering */
    resultaten: OverlijdensRisicoResultaat[] | null;
    messages: string[] | null;
    isValid: boolean;
}

/** Berekende premie */
export interface OverlijdensRisicoPremieOutput {
    /** Premie bedrag */
    bedrag: number;
    /** Premie bedrag inclusief premievrijstelling bij arbeidsongeschiktheid */
    bedragInclusiefPva: number | null;
    /** Premie bedrag exclusief premievrijstelling bij arbeidsongeschiktheid */
    bedragExclusiefPva: number | null;
    /** Looptijd in maanden */
    looptijdInMaanden: number;
}

/** Resultaat van een berekening */
export interface OverlijdensRisicoResultaat {
    /** Unieke identificatie */
    id: string;
    /** Productcode waarvoor de uitvoer geldt. */
    productcode: number;
    /** Berekende premies. */
    premies: OverlijdensRisicoPremieOutput[] | null;
    /** Berekende premies. */
    melding: string | null;
    messages: string[] | null;
    isValid: boolean;
}

/** Gegevens van een verzekerde van een overlijdensrisicoverzekering. */
export interface OverlijdensRisicoVerzekerdeInput {
    /** Unieke identificatie */
    id: number;
    /** Datum wanneer de verzekerde is gestopt met roken */
    stopDatumRoken: string | null;
    /** Rookwaar per dag */
    rookwaarPerDag: number | null;
    /** Premievrijstelling bij arbeidsongeschiktheid */
    pva: boolean | null;
    /** Inkomen van de verzekerde */
    inkomen: number | null;
    /** Eindkapitaal */
    eindkapitaal: number | null;
    /** Verzekerd bedrag */
    verzekerdBedrag: number;
    uitkering: UitkeringOpties;
    /** Is een roker */
    roker: boolean | null;
    geslacht: GeslachtOpties;
    /** Geboortedatum */
    geboorteDatum: string;
    /** Annuiteits percentage */
    annuiteitsPercentage: number | null;
}

/** Gegevens over de gewenste overlijdensrisicoverzekering. */
export interface OverlijdensRisicoVerzekeringInput {
    /** Ingangsdatum */
    ingangsDatum: string;
    betalingsTermijn: BetalingstermijnOpties;
    /** Looptijd in maanden */
    looptijdInMaanden: number;
}

/** PremieverloopOpties Gelijkblijvend = 0, Variabel = 1 */
export enum PremieverloopOpties {
    Gelijkblijvend = "Gelijkblijvend",
    Variabel = "Variabel",
}

/** Product */
export interface Product {
    /** Id */
    id: number;
    /** Naam van het product */
    naam: string | null;
}

/** UitkeringOpties LineairDalend = 1, AnnuitairDalend = 2, Gelijkblijvend = 3, Eenjarig = 4, NabestaandeRente = 7 */
export enum UitkeringOpties {
    LineairDalend = "LineairDalend",
    AnnuitairDalend = "AnnuitairDalend",
    Gelijkblijvend = "Gelijkblijvend",
    Eenjarig = "Eenjarig",
    NabestaandeRente = "NabestaandeRente",
}

/** Gegevens over de validatie van een product. */
export interface Validatie {
    /** Minimale leeftijd bij aanvang. */
    minimaleLeeftijdAanvang: number | null;
    /** Maximale leeftijd bij aanvang. */
    maximaleLeeftijdAanvang: number | null;
    /** Maximale leeftijd bij aanvang voor rokers. */
    maximaleLeeftijdAanvangRoker: number | null;
    /** Op basis van uitkeringsoort kunnen uitzonderingen gemaakt worden op de maximale leeftijd bij aanvang. */
    maximaleLeeftijdAanvangObvUitkeringsoort: MaximaleLeeftijdAanvangObvUitkeringsoort | null;
    /** Maximale leeftijd bij einde. */
    maximaleLeeftijdEinde: number | null;
    /** Maximale leeftijd bij einde voor rokers. */
    maximaleLeeftijdEindeRoker: number | null;
    /** De maximale looptijd. */
    looptijdMaximaal: number | null;
    /** De minimale looptijd. */
    looptijdMinimaal: number | null;
    /** Maximaal aantal maanden in de toekomst. */
    maximaalMaandenTotAanvang: number | null;
    /** Aanvang op 1e van de maand. */
    opEersteVanDeMaand: boolean | null;
    /** Datum in verleden. */
    aanvangInVerledenMogelijk: boolean | null;
    /** Minimaal bedrag. */
    bedragMinimaal: number | null;
    /** Maximaal bedrag. */
    bedragMaximaal: number | null;
    /** Op basis van leeftijd kunnen uitzonderingen gemaakt worden op het maximaal bedrag. */
    bedragMaximaalObvLeeftijd: { [key: string]: number; } | null;
    /** Minimum annuiteitspercentage. */
    minimumAnnuiteitPercentage: number | null;
    /** Maximum annuiteitspercentage. */
    maximumAnnuiteitPercentage: number | null;
    /** Premieverloop */
    premieverlopen: PremieverloopOpties[] | null;
    /** 2-levens mogelijk. */
    mogelijkOp2: boolean | null;
    /** De beperkingen op betalingstermijn. Een lege lijst levert geen beperkingen. */
    betalingstermijnen: BetalingstermijnOpties[] | null;
}

/** Geeft informatie over de opgevraagde validaties. */
export interface ValidatiesOutput {
    /** De gevraagde informatie over validaties per productcode. */
    validaties: { [key: string]: Validatie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface MaximaleLeeftijdAanvangObvUitkeringsoort {
    Geen: number;
    LineairDalend: number;
    "AnnuïtairDalend": number;
    Gelijkblijvend: number;
    JaarlijksVastTeStellen: number;
    PercentageFondswaarde: number;
    SomBetaaldePremies: number;
    NabestaandenRente: number;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}